import { hotRanking, type TrendDirection } from "@/mocks/homeData";

const trendMeta: Record<TrendDirection, { icon: string; className: string; label: string }> = {
  up: { icon: "ri-arrow-up-line", className: "text-primary-600", label: "上升" },
  down: { icon: "ri-arrow-down-line", className: "text-secondary-600", label: "回落" },
  flat: { icon: "ri-subtract-line", className: "text-foreground-400", label: "持平" },
};

export default function HotRanking() {
  const maxHeat = Math.max(...hotRanking.map((item) => item.heat));

  return (
    <section id="rank" className="border-b border-background-200 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-5xl px-4 md:px-8">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold tracking-[0.25em] text-primary-600 md:text-sm">
              <i className="ri-fire-line"></i>
              HOT RANKING
            </p>
            <h2 className="mt-3 font-heading text-3xl font-black text-foreground-950 md:text-5xl">热度榜单</h2>
            <p className="mt-4 max-w-xl text-sm leading-loose text-foreground-600 md:text-base">
              按新鲜程度、多源提及次数与跟进活跃度综合排序，热度值只作相对参考，帮你在最短时间内锁定当下最值得看的瓜点。
            </p>
          </div>
          <span className="hidden shrink-0 items-center gap-2 rounded-full border border-background-200 bg-background-100 px-4 py-2 text-xs font-medium text-foreground-600 md:inline-flex">
            <span className="hl-pulse-dot h-2 w-2 rounded-full bg-primary-500"></span>
            实时滚动更新
          </span>
        </div>

        <div className="mt-10 flex flex-col divide-y divide-background-200 border-y border-background-200">
          {hotRanking.map((item) => {
            const trend = trendMeta[item.trend];
            const isTop = item.rank <= 3;

            return (
              <a
                key={item.id}
                href="#feed"
                className="group flex cursor-pointer items-center gap-4 py-5 md:gap-7 md:py-6"
              >
                <span
                  className={`w-10 shrink-0 font-heading text-3xl font-black leading-none tabular-nums md:w-14 md:text-4xl ${
                    isTop ? "text-primary-500" : "text-background-400"
                  }`}
                >
                  {String(item.rank).padStart(2, "0")}
                </span>

                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <span
                      className={`rounded-full px-2.5 py-0.5 text-[11px] font-medium ${
                        isTop ? "bg-accent-100 text-accent-900" : "bg-secondary-100 text-secondary-900"
                      }`}
                    >
                      {item.category}
                    </span>
                    <span className="text-[11px] text-foreground-400">{item.note}</span>
                  </div>
                  <p className="mt-2 truncate text-sm font-semibold text-foreground-900 transition-colors group-hover:text-primary-600 md:text-lg">
                    {item.title}
                  </p>
                  <div className="mt-3 h-1.5 w-full overflow-hidden rounded-full bg-background-100">
                    <div
                      className={`h-full rounded-full transition-all duration-500 ${
                        isTop ? "bg-primary-500" : "bg-secondary-400"
                      }`}
                      style={{ width: `${Math.round((item.heat / maxHeat) * 100)}%` }}
                    ></div>
                  </div>
                </div>

                <div className="hidden w-24 shrink-0 flex-col items-end md:flex">
                  <span className="font-heading text-2xl font-black tabular-nums text-foreground-900">{item.heat}</span>
                  <span className={`mt-1 flex items-center gap-1 text-xs ${trend.className}`}>
                    <i className={trend.icon}></i>
                    {trend.label}
                  </span>
                </div>

                <div className="flex w-16 shrink-0 flex-col items-end md:hidden">
                  <span className="font-heading text-lg font-black tabular-nums text-foreground-900">{item.heat}</span>
                  <i className={`${trend.icon} text-xs ${trend.className}`}></i>
                </div>
              </a>
            );
          })}
        </div>

        <div className="mt-8 flex justify-center md:justify-start">
          <a
            href="#feed"
            className="inline-flex items-center gap-2 whitespace-nowrap text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700"
          >
            在快讯流里查看完整时间线
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}